import React from 'react';

import { CopyToClipboardIconButton } from '@packages/fenrir/components/clipboard/copy-to-clipboard-icon-button';
import { Stack, type StackProps } from '@packages/fenrir/components/stack';
import { Typography } from '@packages/fenrir/components/typography';
import { useGetToken } from '@packages/legacy/auth';

export const CopyToken: React.FC<StackProps> = ({ ...rest }) => {
  const authToken = useGetToken();

  return authToken ? (
    <Stack alignItems="center" direction="row" spacing={1} {...rest}>
      <Typography>Copy Bearer token:</Typography>
      <CopyToClipboardIconButton value={authToken} />
    </Stack>
  ) : null;
};
